// export const offersApiUrl = "http://localhost:3003/offers"; 
export const offersApiUrl = "https://offerberso.ru/api/offers";
export const itemApiUrl = "https://24berso.ru/articles";

export const managers = ["Анна", "Вадим", "Валерия", "Даниил", "Дмитрий", "Екатерина", "Никита", "Николай", "Павел", "Татьяна"];
